import { observer } from 'mobx-react-lite';
import { useStore } from '../../contexts/StoreContext';
import Toast from './Toast';
import useResponsiveScreen from 'src/hooks/useResponsiveScreen';
import { toastNotificationTestID } from 'src/helpers/testIDs.helper';
import { styles } from './ToastWrapper.styles';
import Animated, { useAnimatedStyle, useSharedValue, withTiming } from 'react-native-reanimated';
import { useEffect } from 'react';
import { useLayoutDimensionsContext } from 'src/contexts/LayoutDimensionsContext';

const ToastWrapper = observer(() => {
  const {
    toastStore: { visibleToasts },
    project: { bottomSheetLookupHeight, isBottomSheetLookupOpened },
  } = useStore();
  const { isDesktop } = useResponsiveScreen();
  const { toastNotificationBottom } = useLayoutDimensionsContext();
  const bottomSV = useSharedValue(118);

  useEffect(() => {
    const nextBottom =
      bottomSheetLookupHeight > 0
        ? bottomSheetLookupHeight + 16
        : isBottomSheetLookupOpened
          ? 200
          : toastNotificationBottom;
    bottomSV.value = withTiming(nextBottom, { duration: 250 });
  }, [toastNotificationBottom, bottomSheetLookupHeight, isBottomSheetLookupOpened]);

  const animatedStyle = useAnimatedStyle(() => ({
    bottom: bottomSV.value,
    right: 30,
  }));

  return (
    <Animated.View
      testID={toastNotificationTestID()}
      style={[styles.toastWrapper, isDesktop ? styles.toastWrapperDesktop : animatedStyle]}
    >
      {visibleToasts?.map((toast, index) => (
        <Toast key={toast.group} index={index} {...toast} />
      ))}
    </Animated.View>
  );
});

export default ToastWrapper;
